import { render, staticRenderFns } from "./LastComposerUpdate.vue?vue&type=template&id=6b0b63c8&"
import script from "./LastComposerUpdate.vue?vue&type=script&lang=js&"
export * from "./LastComposerUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports